import {
  beforeAndAfterSection,
  contactFormSection,
  credentialsSection,
  embeddedVideoSection,
  faqsSection,
  featuredTestimonialSection,
  featuresSection,
  freeFormSection,
  geotaggedProjectsSection,
  iframeSection,
  ourProcessSection,
  partnershipsSection,
  photoCarouselSection,
  projectsSection,
  textSection,
  videoHeroSection,
} from "../sections/individualSections";

const MISC_SECTIONS = [
  geotaggedProjectsSection,
  embeddedVideoSection,
  ourProcessSection,
  featuredTestimonialSection,
  iframeSection,
  projectsSection,
  faqsSection,
  freeFormSection,
  videoHeroSection,
  photoCarouselSection,
  contactFormSection,
  beforeAndAfterSection,
  featuresSection,
  credentialsSection,
  textSection,
  partnershipsSection,
];

export default MISC_SECTIONS.map((s, idx) => ({ ...s, order: idx + 1 }));
